import React from 'react';
import MatchRowUpcoming from './MatchRowUpcoming';
import MatchRowOngoing from './MatchRowOngoing';
import MatchRowFinished from './MatchRowFinished';

function MatchRow({ item }) {
  if (item.status === 'UPCOMING') {
    return <MatchRowUpcoming match={item} />;
  }

  if (item.status === 'ONGOING') {
    return <MatchRowOngoing match={item} />;
  }

  if (item.status === 'FINISHED') {
    return <MatchRowFinished match={item} />;
  }

  return null;
}

export default MatchRow;
